import request from "@/axios";

/** 获取用户标签字典 */
export function getUserTagsDict() {
  return request({
    url: '/lebo-desk/appresourceitem/allUserTags',
    method: 'get'
  })
}

/** 资源位w */
export function resetCodeSort(params, data) {
  return request({
    url: '/lebo-desk/appresourceitem/resetCodeSort',
    method: 'post',
    params,
    data
  })
}
